import { HygienaAuthElement } from "./element.js";

/** @returns {void} */
export function registerHygienaAuthElement() {
  if (typeof window === "undefined" || typeof customElements === "undefined") {
    return;
  }

  if (customElements.get(HygienaAuthElement.TAG_NAME)) {
    return;
  }

  customElements.define(HygienaAuthElement.TAG_NAME, HygienaAuthElement);
}
